import type { ResolvedComponent } from '@inertiajs/react'
import type { ReactNode } from 'react'
import AppLayout from '../layouts/AppLayout'

type PageModule = { default: ResolvedComponent }

const pages = import.meta.glob<PageModule>(['../pages/**/*.tsx', '!../pages/**/*.test.tsx'], { eager: true })

export default function resolvePage(name: string) {
  const page = pages[`../pages/${name}.tsx`]
  if (!page) throw new Error(`Missing Inertia page component: ${name}.tsx`)
  page.default.layout ??= (child: ReactNode) => <AppLayout>{child}</AppLayout>
  return page
}
